import Datepicker from "react-tailwindcss-datepicker";

export default function DateRangePicker({
  value = { fromDate: null, toDate: null, startDate: null, endDate: null },
  onChange,
  placeholder = "DD-MM-YYYY ~ DD-MM-YYYY",
  classNames = "ring-1 bg-grey-datepick",
  displayFormat = "DD-MM-YYYY",
  showFooter = true,
  configs,
  required = false,
}) {
  const mappedValue = {
    startDate: value?.fromDate ?? value?.startDate ?? null,
    endDate: value?.toDate ?? value?.endDate ?? null,
  };

  return (
    <Datepicker
      value={mappedValue}
      onChange={(newValue) => {
        const mappedOnChange = {
          fromDate: newValue?.startDate ?? newValue?.fromDate ?? null,
          toDate: newValue?.endDate ?? newValue?.toDate ?? null,
        };

        onChange && onChange(mappedOnChange);
      }}
      separator=" ~ "
      displayFormat={displayFormat}
      showFooter={showFooter}
      popoverDirection="down"
      configs={{
        footer: {
          cancel: configs?.footer?.cancel || "Cancel",
          apply: configs?.footer?.apply || "Apply",
        },
      }}
      inputClassName={classNames}
      useRange={true}
      asSingle={false}
      placeholder={placeholder}
      required={required}
    />
  );
}